// src/modules/Onboarding/runtime/external/featureFlags.ts
//
// Feature keys resolved locally, i.e. NOT remote experiments. A screen JSON
// config references one through a `featureKey` condition; the renderer then asks
// the host via its `feature-flag-callback` prop, which lands in
// `resolveFeatureFlag` (useOnboardingBuilderState.ts) and checks, in order:
//
//   1. the `funnelFeatureFlag` override from the userFlags store
//   2. this map
//   3. false — ABSmartly is removed from this repo, so there is no remote tier
//
// Single source of truth: `useOnboardingStepEvents.js` also reads this map to
// decide whether a `featureKey` condition is locally resolved (so the step event
// is logged as `is_control: true`) or an experiment. Don't duplicate a key
// anywhere else — in particular, not back into `@/helpers/constants`.
//
// Contract: `defineFeatureFlag({ description, type, resolve })`.
//
// Currently EMPTY, and that is deliberate: no Kova config uses a `featureKey`
// condition, so the callback is never invoked. The two keys that used to live
// here as `LOCAL_FEATURE_KEY_HANDLERS` (`hide_age_selection_screen`,
// `disable_weight_loss_boost`) came from simple-performance-web and gated things
// this repo doesn't have — an `lptype` landing param that is read nowhere, and a
// weight-loss-boost upsell (both funnels ship `upsell: { routeNames: [] }`).
// Dropped rather than kept as entries that would advertise themselves in the
// builder UI and then always resolve to false.

import { type FeatureFlagsMap } from '../types'

export const featureFlags = {} satisfies FeatureFlagsMap
